"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceOracle__factory = void 0;
var ethers_1 = require("ethers");
var _abi = [
    {
        inputs: [
            {
                internalType: "contract IController",
                name: "_controller",
                type: "address",
            },
            {
                internalType: "address",
                name: "_masterQuoteAsset",
                type: "address",
            },
            {
                internalType: "address[]",
                name: "_adapters",
                type: "address[]",
            },
            {
                internalType: "address[]",
                name: "_assetOnes",
                type: "address[]",
            },
            {
                internalType: "address[]",
                name: "_assetTwos",
                type: "address[]",
            },
            {
                internalType: "contract IOracle[]",
                name: "_oracles",
                type: "address[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_adapter",
                type: "address",
            },
        ],
        name: "AdapterAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_adapter",
                type: "address",
            },
        ],
        name: "AdapterRemoved",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_newMasterQuote",
                type: "address",
            },
        ],
        name: "MasterQuoteAssetEdited",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_assetOne",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_assetTwo",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_oracle",
                type: "address",
            },
        ],
        name: "PairAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_assetOne",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_assetTwo",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_newOracle",
                type: "address",
            },
        ],
        name: "PairEdited",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_assetOne",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_assetTwo",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_oracle",
                type: "address",
            },
        ],
        name: "PairRemoved",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "adapters",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_adapter",
                type: "address",
            },
        ],
        name: "addAdapter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_assetOne",
                type: "address",
            },
            {
                internalType: "address",
                name: "_assetTwo",
                type: "address",
            },
            {
                internalType: "contract IOracle",
                name: "_oracle",
                type: "address",
            },
        ],
        name: "addPair",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "controller",
        outputs: [
            {
                internalType: "contract IController",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_newMasterQuoteAsset",
                type: "address",
            },
        ],
        name: "editMasterQuoteAsset",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_assetOne",
                type: "address",
            },
            {
                internalType: "address",
                name: "_assetTwo",
                type: "address",
            },
            {
                internalType: "contract IOracle",
                name: "_oracle",
                type: "address",
            },
        ],
        name: "editPair",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getAdapters",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_assetOne",
                type: "address",
            },
            {
                internalType: "address",
                name: "_assetTwo",
                type: "address",
            },
        ],
        name: "getPrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "masterQuoteAsset",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "oracles",
        outputs: [
            {
                internalType: "contract IOracle",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_adapter",
                type: "address",
            },
        ],
        name: "removeAdapter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_assetOne",
                type: "address",
            },
            {
                internalType: "address",
                name: "_assetTwo",
                type: "address",
            },
        ],
        name: "removePair",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
var PriceOracle__factory = /** @class */ (function (_super) {
    __extends(PriceOracle__factory, _super);
    function PriceOracle__factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    PriceOracle__factory.prototype.deploy = function (_controller, _masterQuoteAsset, _adapters, _assetOnes, _assetTwos, _oracles, overrides) {
        return _super.prototype.deploy.call(this, _controller, _masterQuoteAsset, _adapters, _assetOnes, _assetTwos, _oracles, overrides || {});
    };
    PriceOracle__factory.prototype.getDeployTransaction = function (_controller, _masterQuoteAsset, _adapters, _assetOnes, _assetTwos, _oracles, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _controller, _masterQuoteAsset, _adapters, _assetOnes, _assetTwos, _oracles, overrides || {});
    };
    PriceOracle__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    PriceOracle__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    PriceOracle__factory.createInterface = function () {
        return new ethers_1.utils.Interface(_abi);
    };
    PriceOracle__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    PriceOracle__factory.bytecode = _bytecode;
    PriceOracle__factory.abi = _abi;
    return PriceOracle__factory;
}(ethers_1.ContractFactory));
exports.PriceOracle__factory = PriceOracle__factory;
//# sourceMappingURL=PriceOracle__factory.js.map